import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import * as H from '../helpers'
import workProp from '../workProp'

const prefix = H.getThumbUrlPrefix('work-posters')

const getShortThumbsWidth = (works) => {
  const reducer = (acc, w) => ((30 / w.videoRatio) * 100) + acc
  const width = Math.floor(works.reduce(reducer, 0) - 1)
  return width
}

const Pagination = ({ activeIndex, onClick, top, works }) => (
  <ul
    id="thumbs"
    className={cx('pagination', { short: works.length < 5 })}
    style={{
      width: getShortThumbsWidth(works),
      top,
    }}
  >
    {works.map((work, index) => (
      // eslint-disable-next-line
      <li
        key={work.slug}
        onClick={onClick(index)}
        className={cx({
          active: index === activeIndex,
          first: index === 0,
        })}
        style={{
          flex: work.images[0].thumbs[0].width / work.images[0].thumbs[0].height,
        }}
      >
        <img
          src={`${prefix}${work.images[0].thumbs[0].name}`}
          alt=""
        />
      </li>
    ))}
  </ul>
)

Pagination.propTypes = {
  activeIndex: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  // eslint-disable-next-line
  top: PropTypes.number.isRequired,
  works: workProp.isRequired,
}

export default Pagination



// WEBPACK FOOTER //
// ./src/components/Pagination.js